<ng-container *ngIf="dialogData?.mission">
    <div class="page-body">
        <div class="missions-games-bundle">
        <div class="mission-wrapper" fxLayout="row">
            <h2>Mission Games:</h2>
            <!-- <app-mission-info-box *ngIf="dialogData.isInGame || !isLogin" [isModalDisplay]="true" [mission]="dialogData.mission">
            </app-mission-info-box> -->
            <!-- <ng-container *ngIf="!dialogData?.mission?.streamingChannelName">
                <div class="game-wrapper" fxLayoutAlign="center center">
                    <div class="mission-start-game" *ngIf="!dialogData.isInGame && isLogin && mission.games.length === 1" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="thumbnail" fxFlex="50">
                            <img src="{{ mission.games[0].thumbnail.url }}" />
                        </div>
                        <div fxLayoutAlign="center center" fxLayout="column" class="title-right-tile" fxFlex="50">
                            <div class="game-info">
                                <h1 class="game-title" mat-dialog-title>{{dialogData.mission.games[0].name}}</h1>
                                <button *loggedRender class="launch-game" mat-flat-button color="primary" (click)="launchGame(dialogData.mission.games[0].gameid,dialogData.mission.games[0].systemName)" i18n>play game</button>
                            </div>
                        </div>
                    </div>
                </div>
                <swiper *ngIf="!dialogData.isInGame && isLogin && mission.games.length > 1" fxFlex="auto" class="operator-swiper" [config]="config">
                    <ng-template swiperSlide *ngFor="let game of mission.games">
                        <div class="mission-game-card" (click)="launchGame(game.gameid,game.systemName)" fxLayoutAlign="center center" fxLayout="column">
                            <div class="thumbnail">
                                <img src="{{ game.thumbnail.url }}" />
                            </div>
                            <div class="title" mat-dialog-title>{{game.name}}</div>
                        </div>
                    </ng-template>
                </swiper>
            </ng-container> -->

        </div>
        <div class="swipper-mission-wrapper" *ngIf="isLogin">
            <swiper *ngIf="mission.games" fxFlex="auto" class="operator-swiper" [config]="config">
                <ng-template swiperSlide *ngFor="let game of mission.games">
                    <div class="tournament-game-card" (click)="launchGame(game.gameid,game.systemName)" fxLayoutAlign="center center" fxLayout="column">
                        <div class="thumbnail">
                            <img src="{{ game.thumbnail.url }}" />
                        </div>
                        <div class="title" mat-dialog-title>{{game.name}}</div>
                    </div>
                </ng-template>
            </swiper>
        </div>
    </div>
        <div class="separtor"></div>

        <!-- <router-outlet></router-outlet> -->
        <div class="mission-tab mobile">

            <mat-tab-group headerPosition="below" mat-stretch-tabs [selectedIndex]="tabIndex" (selectedTabChange)="onTabChange($event)">
                <mat-tab labelClass="mission-tab-header">
                    <ng-template mat-tab-label>
                        <img class="icon-header" src="{{licenceService.getKey('icon-mission-home')}}">
                        <p class="tab-para-text" i18n style="margin: 0;">Tasks</p>
                    </ng-template>
                    <app-mission-overview [ref]="dialogData.mission.ref" [mission]="dialogData.mission"></app-mission-overview>
                </mat-tab>
                <mat-tab labelClass="mission-tab-header">
                    <ng-template mat-tab-label>
                        <img class="icon-header" src="{{licenceService.getKey('icon-rule')}}">
                        <p class="tab-para-text" i18n style="margin: 0;">Info</p>
                    </ng-template>
                    <app-mission-rules [mission]="dialogData.mission"></app-mission-rules>
                </mat-tab>
                <mat-tab labelClass="mission-tab-header">
                    <ng-template mat-tab-label>
                        <img class="icon-header" src="{{licenceService.getKey('icon-list')}}">
                        <p class="tab-para-text" i18n style="margin: 0;">Games</p>
                    </ng-template>
                    <app-mission-prizes [mission]="dialogData.mission"></app-mission-prizes>
                </mat-tab>
            </mat-tab-group>
        </div>

    </div>
</ng-container>
<app-close-dialog-button (closeEvent)="closeDialog()" [customClass]="'medium'"></app-close-dialog-button>
<ng-template #notenoughfunds>
    <div class="not-enough-funds-text">
        <span i18n>No funds</span>
    </div>
</ng-template>